export enum RdxDevTerminologyType {
    waterfall = 1,
    safe = 2
}

export enum IterationTerminologyType {
    iteration = 1,
    sprint = 2
}
